//<link rel="preload" href="sintel-short.mp4" as="video" type="video/mp4"/>
import MediaTypeEnum from '../enums/MediaType'

export const getMediaMetadata = (media) => {
  if (media?.cloudinaryAsset && media?.cloudinaryAsset.length > 0) {
    // CloudinaryAsset Video
    if (media?.cloudinaryAsset[0].resource_type === MediaTypeEnum.video) {
      return {
        url: media.cloudinaryAsset[0].secure_url,
        asType: MediaTypeEnum.video,
      }
    }
  }
  // CloudinaryAsset Image
  if (media?.cloudinaryAsset &&
    media?.cloudinaryAsset.length > 0 &&
    media?.cloudinaryAsset[0]?.resource_type === MediaTypeEnum.image
  ) {
    return {
      url: media.cloudinaryAsset[0].secure_url,
      asType: MediaTypeEnum.image,
    }
  }

  if(media?.contentfulAsset && media?.contentfulAsset.file.contentType === 'video/mp4') {
    return {
      url: media.contentfulAsset.url,
      asType: MediaTypeEnum.video,
    }
  }

  return null
}